import { useEffect, useState } from 'react';
import { getInitials } from '../../../utils';

interface TdmLeadProps {
  name: string;
  image?: string;
  title?: string;
}
export const TdmLead = (props: TdmLeadProps) => {
  const { name, image = '', title = '' } = props;
  const [imageLoadError, setImageLoadError] = useState<boolean>(false);
  useEffect(
    () => () => {
      setImageLoadError(false);
    },
    []
  );

  return (
    <div className='flex gap-4'>
      {!image || imageLoadError ? (
        <div
          className={
            'bg-gray-200 rounded-full flex justify-center items-center text-2xl p-2 text-primaryColor-normal font-bold tracking-wider'
          }
          style={{
            width: '91px',
            height: '91px',
          }}
        >
          {getInitials(name)}
        </div>
      ) : (
        <img
          className='rounded-full object-cover'
          onLoad={() => {
            setImageLoadError(false);
          }}
          onError={() => {
            setImageLoadError(true);
          }}
          src={image}
          style={{
            width: '91px',
            height: '91px',
          }}
        />
      )}
      <div>
        <p className='text-lg font-medium text-back mb-1'>{name}</p>
        <p>{title}</p>
      </div>
    </div>
  );
};
